// import React, { useEffect, useRef } from 'react';

// const UpdatedComponent = () => {
//     const buttonRef = useRef(null);

//     useEffect(() => {
//         const now = new Date();
//         const desiredTime = new Date(now);
//         desiredTime.setHours(9, 5, 0, 0); // Set to 9:00 AM

//         if (now.getHours() === 9 && now.getMinutes() === 5) {
//             // If the current time is exactly 9:00 AM, execute the batch file immediately
//             buttonRef.current?.click();
//         } else {
//             let timeDifference = desiredTime - now;
//             if (timeDifference < 0) {
//                 // If the current time is past 9:00 AM, set the timer for the next day at 9:00 AM
//                 desiredTime.setDate(desiredTime.getDate() + 1);
//                 timeDifference = desiredTime - now;
//             }

//             const timerId = setTimeout(() => {
//                 buttonRef.current?.click(); // Trigger the button click
//             }, timeDifference);

//             // Cleanup the timer if the component unmounts
//             return () => clearTimeout(timerId);
//         }
//     }, []);

//     // useEffect(() => {
//     //     const now = new Date();
//     //     const desiredTime = new Date(now);
//     //     desiredTime.setHours(16, 30, 0, 0); // Set to 4:30 PM

//     //     if (now.getHours() === 16 && now.getMinutes() === 30) {
//     //         // If the current time is exactly 4:30 PM, execute the batch file immediately
//     //         buttonRef.current?.click();
//     //     } else {
//     //         let timeDifference = desiredTime - now;
//     //         if (timeDifference < 0) {
//     //             // If the current time is past 4:30 PM, set the timer for the next day at 4:30 PM
//     //             desiredTime.setDate(desiredTime.getDate() + 1);
//     //             timeDifference = desiredTime - now;
//     //         }

//     //         const timerId = setTimeout(() => {
//     //             buttonRef.current?.click(); // Trigger the button click
//     //         }, timeDifference);

//     //         // Cleanup the timer if the component unmounts
//     //         return () => clearTimeout(timerId);
//     //     }
//     // }, []);

//     const openBatchFile = async () => {
//         try {
//             const response = await fetch('http://183.182.84.228:4005/openapp/');
//             if (response.ok) {
//                 const result = await response.text();
//                 console.log(result);
//             } else {
//                 console.error('Failed to open batch file');
//             }
//         } catch (error) {
//             console.error('Error opening batch file:', error);
//         }
//     };

//     return (
//         <div>
//             <h1>My React App</h1>
//             <button ref={buttonRef} onClick={openBatchFile}>
//                 Open App
//             </button>
//         </div>
//     );
// };

// export default UpdatedComponent;









// import React, { useEffect, useRef, useState } from 'react';

// const UpdatedData = () => {
//     const buttonRef = useRef(null);
//     const [clickCount, setClickCount] = useState(0);
//     const [currentDate, setCurrentDate] = useState(new Date().toLocaleDateString());

//     // useEffect(() => {
//     //     const checkAndRunBatchFile = () => {
//     //         fetch('http://183.182.84.228:4005/check-and-run', {
//     //             method: 'POST',
//     //         })
//     //         .then(response => response.json())
//     //         .then(data => {
//     //             console.log(data.message);
//     //             if (data.status === "success") {
//     //                 setClickCount(prevCount => prevCount + 1);
//     //                 setCurrentDate(new Date().toLocaleDateString());
//     //             }
//     //         })
//     //         .catch(error => console.error('Error:', error));
//     //     };

//     //     // Call the function immediately to check the date and potentially run the batch file
//     //     checkAndRunBatchFile();
//     // }, []);

//     const openBatchFile = async () => {
//         try {
//             const response = await fetch('http://183.182.84.228:4005/run-batch', {
//                 method: 'POST',
//             });
//             if (response.ok) {
//                 const result = await response.json();
//                 console.log(result.message);
//                 setClickCount(prevCount => prevCount + 1);
//                 setCurrentDate(new Date().toLocaleDateString());
//             } else {
//                 console.error('Failed to open batch file');
//             }
//         } catch (error) {
//             console.error('Error opening batch file:', error);
//         }
//     };

//     return (
//         <div>
//             <h1>My React App</h1>
//             <button ref={buttonRef} onClick={openBatchFile}>
//                 Update Data
//             </button>
//             <div>
//                 <p>Today's Date: {currentDate}</p>
//                 <p>Number of times the button clicked: {clickCount}</p>
//             </div>
//         </div>
//     );
// };

// export default UpdatedData;


















































// import React, { useRef, useState } from 'react';

// const UpdatedData = () => {
//     const buttonRef = useRef(null);
//     const [clickCount, setClickCount] = useState(0);
//     const [currentDate, setCurrentDate] = useState(new Date().toLocaleDateString());
//     const [isButtonDisabled, setIsButtonDisabled] = useState(false);

//     const openBatchFile = async () => {
//         alert('Batch file is being executed. Please wait 5 minutes before clicking again.');
//         setIsButtonDisabled(true);
//         setTimeout(() => setIsButtonDisabled(false), 300000); // Disable button for 5 minutes

//         try {
//             const response = await fetch('http://183.182.84.228:4005/run-batch', {
//                 method: 'POST',
//             });
//             if (response.ok) {
//                 const result = await response.json();
//                 // console.log(result.message);
//                 setClickCount(prevCount => prevCount + 1);
//                 setCurrentDate(new Date().toLocaleDateString());
//             } else {
//                 console.error('Failed to open batch file');
//             }
//         } catch (error) {
//             console.error('Error opening batch file:', error);
//         }
//     };



//     const openBatchStock = async () => {
//         alert('Batch file is being executed. Please wait 5 minutes before clicking again.');
//         setIsButtonDisabled(true);
//         setTimeout(() => setIsButtonDisabled(false), 300000); // Disable button for 5 minutes

//         try {
//             const response = await fetch('http://183.182.84.228:4005/run-stocklimit', {
//                 method: 'POST',
//             });
//             if (response.ok) {
//                 const result = await response.json();
//                 // console.log(result.message);
//                 setClickCount(prevCount => prevCount + 1);
//                 setCurrentDate(new Date().toLocaleDateString());
//             } else {
//                 console.error('Failed to open batch file');
//             }
//         } catch (error) {
//             console.error('Error opening batch file:', error);
//         }
//     };






//     return (
//         <div>
//             <h1>My React App</h1>
//             <button ref={buttonRef} onClick={openBatchFile} disabled={isButtonDisabled}>
//             {isButtonDisabled ? 'Please wait...' : 'Update Data'}
//             </button>
//             <br/>
//             <button ref={buttonRef} onClick={openBatchStock} disabled={isButtonDisabled}>
//             {isButtonDisabled ? 'Please wait...' : 'Update Stock Limits'}
//             </button>
//             <div>
//                 <p>Today's Date: {currentDate}</p>
//                 <p>Number of times the button clicked: {clickCount}</p>
//             </div>
//         </div>
//     );
// };

// export default UpdatedData;







import React, { useState } from 'react';

const SaudabookProcessor = () => {
    // State management
    const [clickCount, setClickCount] = useState(0);
    const [currentDate] = useState(new Date().toLocaleDateString());
    const [selectedDate, setSelectedDate] = useState('');
    const [status, setStatus] = useState({
        dailyTasks: { loading: false, message: '', isError: false, details: '' },
        stockLimits: { loading: false, message: '', isError: false, details: '' },
        saudabook: { loading: false, message: '', isError: false, details: '' }
    });

    // Styles
    const styles = {
        container: {
            maxWidth: '800px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: 'Arial, sans-serif'
        },
        card: {
            background: '#f5f5f5',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        },
        heading: {
            color: '#333',
            textAlign: 'center'
        },
        subHeading: {
            color: '#444',
            marginTop: '0'
        },
        datePicker: {
            display: 'flex',
            gap: '10px',
            margin: '15px 0',
            alignItems: 'center'
        },
        input: {
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            width: '200px'
        },
        button: {
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            padding: '10px 15px',
            textAlign: 'center',
            textDecoration: 'none',
            display: 'inline-block',
            fontSize: '16px',
            margin: '4px 2px',
            cursor: 'pointer',
            borderRadius: '4px'
        },
        disabledButton: {
            backgroundColor: '#cccccc',
            cursor: 'not-allowed'
        },
        status: {
            marginTop: '10px',
            padding: '8px',
            borderRadius: '4px',
            backgroundColor: '#f8f8f8',
            borderLeft: '4px solid #4CAF50'
        },
        errorStatus: {
            borderLeft: '4px solid #f44336'
        },
        stats: {
            marginTop: '20px',
            padding: '15px',
            backgroundColor: '#e9f7ef',
            borderRadius: '4px',
            textAlign: 'center'
        },
        details: {
            fontSize: '12px',
            overflowX: 'auto',
            whiteSpace: 'pre-wrap',
            backgroundColor: '#f0f0f0',
            padding: '8px',
            borderRadius: '4px',
            marginTop: '8px'
        }
    };

    // Helper functions
    const isValidDate = (dateString) => {
        const regEx = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateString.match(regEx)) return false;
        const d = new Date(dateString);
        return d instanceof Date && !isNaN(d);
    };

    const getStatusStyle = (type) => {
        return status[type].isError ? 
            { ...styles.status, ...styles.errorStatus } : 
            styles.status;
    };

    // API call handler
    const executeBatch = async (endpoint, type, dateParam = null) => {
        setStatus(prev => ({ 
            ...prev, 
            [type]: { 
                loading: true, 
                message: 'Processing...', 
                isError: false,
                details: ''
            } 
        }));
        
        try {
            const bodyData = type === 'saudabook' 
                ? { date: dateParam || selectedDate.trim() } 
                : null;

            const response = await fetch(`http://183.182.84.228:4005/${endpoint}`, {
                method: 'POST',
                headers: type === 'saudabook' ? { 
                    'Content-Type': 'application/json' 
                } : {},
                body: type === 'saudabook' ? JSON.stringify(bodyData) : null
            });

            const result = await response.json();
            
            if (!response.ok) {
                throw new Error(result.message || `HTTP error! status: ${response.status}`);
            }

            setClickCount(prev => prev + 1);
            setStatus(prev => ({ 
                ...prev, 
                [type]: { 
                    loading: false, 
                    message: result.message || 'Success!',
                    isError: false,
                    details: result.details || result.output || ''
                }
            }));
        } catch (error) {
            console.error('Error:', error);
            setStatus(prev => ({ 
                ...prev, 
                [type]: { 
                    loading: false, 
                    message: error.message || 'An unexpected error occurred',
                    isError: true,
                    details: error.details || 
                        (error.response?.data?.details || 'Check backend logs for details')
                }
            }));
        }
    };

    // Button handlers
    const handleDailyTasks = () => executeBatch('run-batch', 'dailyTasks');
    const handleStockLimits = () => executeBatch('run-stocklimit', 'stockLimits');
    const handleSaudabook = async () => {
        if (!selectedDate) {
          setStatus(prev => ({
            ...prev,
            saudabook: {
              loading: false,
              message: 'Please select a date',
              isError: true,
              details: 'Date field is empty'
            }
          }));
          return;
        }
      
        setStatus(prev => ({
          ...prev,
          saudabook: {
            loading: true,
            message: 'Processing...',
            isError: false,
            details: ''
          }
        }));
      
        try {
          const res = await fetch('http://183.182.84.228:4005/process-saudabook', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ date: selectedDate })
          });
      
          const result = await res.json();
      
          setStatus(prev => ({
            ...prev,
            saudabook: {
              loading: false,
              message: result.message,
              isError: !result.success,
              details: result.output || result.warnings || result.details || ''
            }
          }));
        } catch (err) {
          console.error('Saudabook error:', err);
          setStatus(prev => ({
            ...prev,
            saudabook: {
              loading: false,
              message: 'Unexpected error',
              isError: true,
              details: err.message || 'Check backend logs'
            }
          }));
        }
      };
      

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Batch Processing Dashboard</h1>
            
            <div style={styles.card}>
                <h2 style={styles.subHeading}>Daily Tasks Update</h2>
                <button 
                    onClick={handleDailyTasks} 
                    style={status.dailyTasks.loading ? 
                        { ...styles.button, ...styles.disabledButton } : 
                        styles.button}
                    disabled={status.dailyTasks.loading}
                >
                    {status.dailyTasks.loading ? 'Processing...' : 'Run Daily Tasks'}
                </button>
                {status.dailyTasks.message && (
                    <div style={getStatusStyle('dailyTasks')}>
                        <p>{status.dailyTasks.message}</p>
                        {status.dailyTasks.details && (
                            <pre style={styles.details}>{status.dailyTasks.details}</pre>
                        )}
                    </div>
                )}
            </div>

            <div style={styles.card}>
                <h2 style={styles.subHeading}>Stock Limits Update</h2>
                <button 
                    onClick={handleStockLimits} 
                    style={status.stockLimits.loading ? 
                        { ...styles.button, ...styles.disabledButton } : 
                        styles.button}
                    disabled={status.stockLimits.loading}
                >
                    {status.stockLimits.loading ? 'Processing...' : 'Update Stock Limits'}
                </button>
                {status.stockLimits.message && (
                    <div style={getStatusStyle('stockLimits')}>
                        <p>{status.stockLimits.message}</p>
                        {status.stockLimits.details && (
                            <pre style={styles.details}>{status.stockLimits.details}</pre>
                        )}
                    </div>
                )}
            </div>

            <div style={styles.card}>
                <h2 style={styles.subHeading}>Saudabook Processing</h2>
                <div style={styles.datePicker}>
                    <input 
                        type="date" 
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        max={new Date().toISOString().split('T')[0]}
                        style={styles.input}
                    />
                    <button 
                        onClick={handleSaudabook} 
                        style={status.saudabook.loading ? 
                            { ...styles.button, ...styles.disabledButton } : 
                            styles.button}
                        disabled={status.saudabook.loading || !selectedDate}
                    >
                        {status.saudabook.loading ? 'Processing...' : 'Process Saudabook'}
                    </button>
                </div>
                {status.saudabook.message && (
                    <div style={getStatusStyle('saudabook')}>
                        <p>{status.saudabook.message}</p>
                        {status.saudabook.details && (
                            <pre style={styles.details}>{status.saudabook.details}</pre>
                        )}
                    </div>
                )}
            </div>

            <div style={styles.stats}>
                <p>Today's Date: {currentDate}</p>
                <p>Total Executions: {clickCount}</p>
            </div>
        </div>
    );
};

export default SaudabookProcessor;